import { ArrowBackRounded, ChevronRightRounded } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import { mboLfsQtyRecoDashboardServices } from "./data";
import { PageHeader, pageContainerSx } from "./sharedStyles";
import Summary from "./Summary/Summary";
import Detail from "./Detail/Detail";
import Upload from "./Upload/Upload";

function MboLfsQtyReco() {
	const navigate = useNavigate();
	const [currentPath, service] = useOutletContext();

	const tabComponents = {
		[mboLfsQtyRecoDashboardServices.mbo_lfs_qty_reco.types.summary.key]: {
			...mboLfsQtyRecoDashboardServices.mbo_lfs_qty_reco.types.summary,
			component: <Summary />,
		},
		[mboLfsQtyRecoDashboardServices.mbo_lfs_qty_reco.types.detail.key]: {
			...mboLfsQtyRecoDashboardServices.mbo_lfs_qty_reco.types.detail,
			component: <Detail />,
		},
		[mboLfsQtyRecoDashboardServices.mbo_lfs_qty_reco.types.upload.key]: {
			...mboLfsQtyRecoDashboardServices.mbo_lfs_qty_reco.types.upload,
			component: <Upload />,
		},
	};

	const activeTab = tabComponents?.[currentPath];

	return (
		<Box sx={pageContainerSx}>
			<Stack direction="row" alignItems="center" spacing={0.5} mb={1.25}>
				<IconButton size="small" onClick={() => navigate(-1)} sx={{ color: "text.secondary" }}>
					<ArrowBackRounded fontSize="small" />
				</IconButton>
				<Typography variant="caption" color="text.secondary">
					MBO LFS Qty Reco
				</Typography>
				<ChevronRightRounded sx={{ fontSize: 16, color: "text.disabled" }} />
				<Typography variant="caption" fontWeight={600} color="text.primary">
					{service?.name}
				</Typography>
			</Stack>

			<PageHeader
				icon={service?.icon}
				title={service?.name}
				description={service?.description}
			/>

			{activeTab?.component}
		</Box>
	);
}

export default MboLfsQtyReco;
